import React from 'react';
import { cleanPhoneNumber } from '../../../utils/formatters';

interface ClientDataSectionProps {
  formData: any;
  setFormData: (data: any) => void;
  labelStyle: string;
  inputStyle: string;
  isEmailInvalid: boolean | string;
  isDuplicateEmail: boolean;
  isDuplicatePhone: boolean;
  isDocumentDuplicate: boolean;
  isDocumentInvalid: boolean;
  isBrokerProfile: boolean;
  countryCodes: { value: string; label: string }[];
}

export const ClientDataSection: React.FC<ClientDataSectionProps> = ({
  formData, setFormData, labelStyle, inputStyle, isEmailInvalid, isDuplicateEmail, isDuplicatePhone, isDocumentDuplicate, isDocumentInvalid, isBrokerProfile, countryCodes
}) => {
  const handleDocumentChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const numericOnly = e.target.value.replace(/\D/g, '').slice(0, 20);
    setFormData({ ...formData, document_cliente: numericOnly });
  };

  return (
    <section className="space-y-4">
      <h4 className="text-sm font-black text-[#00234F] uppercase border-b pb-2">Datos del Cliente</h4>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div><label className={labelStyle}>Nombres *</label><input type="text" value={formData.nombre_cliente} onChange={e => setFormData({...formData, nombre_cliente: e.target.value})} className={inputStyle} required /></div>
        <div><label className={labelStyle}>Apellidos *</label><input type="text" value={formData.last_name} onChange={e => setFormData({...formData, last_name: e.target.value})} className={inputStyle} required={isBrokerProfile} /></div>
        <div>
          <label className={labelStyle}>Cédula del Cliente *</label>
          <input 
            type="text" 
            inputMode="numeric"
            value={formData.document_cliente || ''} 
            onChange={handleDocumentChange}
            className={`${inputStyle} ${(isDocumentDuplicate || isDocumentInvalid) ? 'border-red-500 bg-red-50 focus:ring-red-500 focus:border-red-500' : ''}`} 
            placeholder="7 a 20 dígitos"
            required 
          />
          {isDocumentDuplicate && <p className="text-[9px] text-red-600 font-bold mt-1 uppercase tracking-tighter">La cédula del cliente no puede ser igual a la del broker</p>}
          {isDocumentInvalid && <p className="text-[9px] text-red-600 font-bold mt-1 uppercase tracking-tighter">La cédula debe tener entre 7 y 20 números</p>}
        </div>
        <div>
          <label className={labelStyle}>Celular *</label>
          <div className="flex gap-2">
            <select 
              value={formData.countryCode_cliente} 
              onChange={e => setFormData({...formData, countryCode_cliente: e.target.value})} 
              className="w-24 border border-gray-300 rounded-lg text-xs font-bold uppercase px-2 py-2 bg-white text-gray-700 shadow-sm focus:ring-2 focus:ring-sky-500/20 focus:border-sky-500 focus:outline-none transition-all"
            >
              {countryCodes.map(c => <option key={c.value} value={c.value}>{c.label}</option>)}
            </select>
            <input 
              type="tel" 
              value={formData.celular_cliente} 
              onChange={e => setFormData({...formData, celular_cliente: e.target.value})} 
              onBlur={e => setFormData({...formData, celular_cliente: cleanPhoneNumber(e.target.value)})}
              className={`${inputStyle} ${isDuplicatePhone ? 'border-red-500 bg-red-50 focus:ring-red-500 focus:border-red-500' : ''}`} 
              required 
            />
          </div>
          {isDuplicatePhone && <p className="text-[9px] text-red-600 font-bold mt-1 uppercase tracking-tighter">El celular del cliente no puede ser igual al del broker</p>}
        </div>
        <div className="sm:col-span-2">
          <label className={labelStyle}>Email del Cliente *</label>
          <input 
            type="email" 
            value={formData.email_cliente} 
            onChange={e => setFormData({...formData, email_cliente: e.target.value})} 
            className={`${inputStyle} ${(isEmailInvalid || isDuplicateEmail) ? 'border-red-500 bg-red-50 focus:ring-red-500 focus:border-red-500' : ''}`} 
            required 
          />
          {isEmailInvalid && <p className="text-[9px] text-red-600 font-bold mt-1 uppercase tracking-tighter">Formato de correo inválido</p>}
          {isDuplicateEmail && <p className="text-[9px] text-red-600 font-bold mt-1 uppercase tracking-tighter">El correo del cliente no puede ser igual al del broker</p>}
        </div>
      </div>
    </section>
  );
};
